module.exports = __webpack_public_path__ + "static/img/dialog-bg2.f7a55d16.png";